import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Button, Flex, Text } from '@mantine/core';

interface Props {
	opened: boolean;
	onClose: () => void;
	onDiscard: () => void;
}

export const LeaveWithoutSavingDrawer = ({ opened, onClose, onDiscard }: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<GenericDrawer
			opened={opened}
			onClose={onClose}
			title={tMipManage('email_templates.editor.leave_confirm.title', {
				defaultValue: 'Leave without saving?',
			})}
			body={
				<Flex direction="column" gap="1rem" h="100%">
					<Text fz="0.8125rem" lh="1.21875rem" c="gray.9">
						{tMipManage('email_templates.editor.leave_confirm.message', {
							defaultValue:
								"You have unsaved changes to this template. If you leave now, they'll be lost.",
						})}
					</Text>

					<Flex direction="column" gap="0.5rem" mt="auto">
						<Button fullWidth onClick={onDiscard}>
							{tMipManage('email_templates.editor.leave_confirm.confirm_label', {
								defaultValue: 'Discard changes',
							})}
						</Button>
						<Button variant="default" fullWidth onClick={onClose}>
							{tMipManage('email_templates.editor.leave_confirm.cancel', {
								defaultValue: 'Keep editing',
							})}
						</Button>
					</Flex>
				</Flex>
			}
		/>
	);
};
